export const omitEmpty = <T extends Record<string, unknown>>(obj: Record<string, unknown>): T => {
  const result: Record<string, unknown> = {};

  for (const [key, value] of Object.entries(obj)) {
    if (value === undefined || value === null || value === "" || Number.isNaN(value)) continue;

    if (Array.isArray(value) && value.length === 0) continue;
    if (typeof value === "object" && value !== null && Object.keys(value).length === 0) continue;

    result[key] = value;
  }

  return result as T;
};
